const SPA_STEP_TO_RETURN_TO = 'availability';

const SPA_STEP_TO_LEAVE = 'extras';

export const resetAfterError = (preventPageReload: boolean) => {
  if (!preventPageReload) {
    window.location.reload();
    return;
  }

  const { pathname } = window.location;
  if (pathname.includes('spa')) {
    window.location.href = pathname.replace(SPA_STEP_TO_LEAVE, SPA_STEP_TO_RETURN_TO);
  }
};
